module.exports = __webpack_public_path__ + "static/media/cv.6952a02a.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/cv.svg
// module id = 2071
// module chunks = 0